//import _ from "lodash";
import dashFetch from '../actions/dashFetch';
import log from 'loglevel';

export default class dashServerApis {
	
	static async lockItems(check, checkItems, debug) {
		return dashServerApis.lockUnlockItemsOnServer(check, checkItems, true, debug)
	}
	
	static async unlockItems(check, checkItems, debug) {
		return dashServerApis.lockUnlockItemsOnServer(check, checkItems, false, debug)
	}

	static async lockAllItems(check, debug) {
		return dashServerApis.lockUnlockItemsOnServer(check, null, true, debug)
	}
	
	static async unlockAllItems(check, debug) {
		return dashServerApis.lockUnlockItemsOnServer(check, null, false, debug)
	}

	static async lockUnlockItemsOnServer(check, checkItems, lock, debug) {
		const f = global.f
		return new Promise(async (resolve, reject) => {
			if (debug) log.info(`Requesting Lock / Unlock All Items for checkId: ${check._id}`);
			let body = { checkId: check._id, lock: lock }
			if (f(check, 'restaurant.demo')) {
				body.demo = true
			}
			let action = "lockUnlockAllCheckItems"
			if (checkItems !== null) {
				action = "lockUnlockCheckItemList"
				body.checkItemIds = checkItems.map(itm => itm._id)
			}
			let url = global.dashServerUrl + '/api/v1/check/' + action;
			dashFetch(url, body, debug).then(({ res, json }) => {
				resolve(json)
			}).catch((err) => { reject(err) })
		})
	}
}